var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10991",
    "data-name": "Group 10991",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_bank",
    "data-name": "vuesax/bold/bank",
    transform: "translate(-294 221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(428 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H19.9V19.9H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.585.829V3.317H0V.829A.832.832,0,0,1,.829,0H15.756A.832.832,0,0,1,16.585.829Z",
    transform: "translate(1.658 14.926)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H1.658V5.8H0Z",
    transform: "translate(4.146 9.122)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H1.658V5.8H0Z",
    transform: "translate(7.463 9.122)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H1.658V5.8H0Z",
    transform: "translate(10.78 9.122)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H1.658V5.8H0Z",
    transform: "translate(14.097 9.122)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M18.865,1.244H.622A.626.626,0,0,1,0,.622.626.626,0,0,1,.622,0H18.865a.626.626,0,0,1,.622.622A.626.626,0,0,1,18.865,1.244Z",
    transform: "translate(0.207 17.621)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M16.062,3.035,8.6.05a.971.971,0,0,0-.614,0L.522,3.035A.888.888,0,0,0,0,3.806V6.559a.832.832,0,0,0,.829.829H15.756a.832.832,0,0,0,.829-.829V3.806A.888.888,0,0,0,16.062,3.035Zm-7.77,2.28A1.244,1.244,0,1,1,9.536,4.072,1.242,1.242,0,0,1,8.292,5.315Z",
    transform: "translate(1.658 1.733)",
    fill: "#292d32"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.976e4a8c3bff1eac597af45789870f49.svg";
export { ForwardRef as ReactComponent };